import { I18nContext } from 'contexts/I18n/I18nProvider'
import { OverlayModalState } from 'core/modal/redux/types'
import SpinnerComponent from 'core/spinner'
import ToasterComponent from 'core/toaster'
import { useContext } from 'react'
import { connect } from 'react-redux'
import { Outlet, useLocation } from 'react-router-dom'
import packageJson from '../../package.json'
import OverlayModalContainer from '../core/modal'
import Navbar from './header/navbar'
import { navbarWithTabs } from './header/navbar/redux/config'
import IdleMonitor from './middlewares/noAuth'
import { ApplicationState } from './redux'

type ComponentProps = {
  modal: {
    overlay: OverlayModalState
  }
}

function ApplicationComponent({ modal }: ComponentProps) {
  const t = useContext(I18nContext)
  const location = useLocation()

  return (
    <>
      <SpinnerComponent />
      <ToasterComponent />
      <IdleMonitor />
      {modal.overlay.active && <OverlayModalContainer />}
      {!navbarWithTabs.some((item) =>
        location.pathname.includes(item)
      ) && <Navbar />}
      <Outlet/>
      <footer className="footer footer-style">
        <div className="content has-text-right">
          Vodafone | {t('footer.copyright')} {new Date().getFullYear()} -{' '}
          {packageJson.version}
        </div>
      </footer>
    </>
  )
}

const mapStateToProps = (state: ApplicationState) => {
  return {
    modal: state.modal,
  }
}

export default connect(mapStateToProps, {})(ApplicationComponent)